import { render } from "./bmedit.vue?vue&type=template&id=1313262b&scoped=true"
import script from "./bmedit.vue?vue&type=script&lang=js"
export * from "./bmedit.vue?vue&type=script&lang=js"

import "./bmedit.vue?vue&type=style&index=0&id=1313262b&lang=scss&scoped=true"
import "./bmedit.vue?vue&type=style&index=1&id=1313262b&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1313262b"]])

export default __exports__